import { Typography } from '@material-ui/core';
import { ContactValidationResult, IdentityVerificationResult } from 'api/file/interfaces/get-file-order-insights';
import clsx from 'clsx';
import { offerMessage } from 'features/help/constants';
import { useHistory } from 'react-router-dom';
import AgentNetButton from 'ui-kit/components/button/AgentNetButton';
import { TransactionStatusEnum } from 'utilities/verification/types';
import ContactInfoDisplay from './ContactInfoDisplay';
import useStyles from './ListStyles';
import VerificationResults from './VerificationResults';

interface IDisabledProducts {
  qaPrefix: string;
  description: string;
  productCode: string;
  isAgentNetAdmin?: boolean;
  index: number;
  contactInfo: ContactValidationResult | null;
  type: 'ContactValidation' | 'EnhancedIdentityVerification';
  identityResults: IdentityVerificationResult | null;
  fileId: string;
}

const DisabledProducts = ({
  qaPrefix,
  description,
  productCode,
  isAgentNetAdmin,
  index,
  contactInfo,
  type,
  identityResults,
  fileId,
}: IDisabledProducts) => {
  const classes = useStyles();
  const history = useHistory();

  const isContactValidationEnabled = contactInfo?.transactionStatus === TransactionStatusEnum.Completed;
  if (isContactValidationEnabled && type === 'ContactValidation') {
    return <ContactInfoDisplay {...contactInfo} />;
  }

  const isIdentityResultStatusCompleted = identityResults?.transactionStatus === TransactionStatusEnum.Completed;
  if (type === 'EnhancedIdentityVerification' && isIdentityResultStatusCompleted) {
    return <VerificationResults {...identityResults} fileId={fileId} index={index} />;
  }

  const handleEnable = () => {
    history.push(`/admin/integrations-features?productCode=${productCode}`);
  };

  if (isAgentNetAdmin) {
    return (
      <>
        <Typography variant="body1" className={clsx(classes.marginBottom, classes.typographyFontSize)}>
          {`${description} ${offerMessage['admin']}`}
        </Typography>
        <AgentNetButton
          variant="contained"
          color="primary"
          data-testid={`${qaPrefix}-button-enable-${index}`}
          size="small"
          onClick={handleEnable}
          className={classes.marginTop}
        >
          Enable
        </AgentNetButton>
      </>
    );
  }

  return (
    <Typography variant="body1" className={clsx(classes.marginBottom, classes.typographyFontSize)}>
      {`${description} ${offerMessage['nonAdmin']}`}
    </Typography>
  );
};

export default DisabledProducts;
